import { workspaceQueryKeys as e } from "./useWorkspaceQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { rolesApi as n } from "@maat/api-main";
//#region src/workspaces/useAllPermissionsQuery.ts
var r = () => t({
	queryKey: e.allPermissions(),
	queryFn: n.getAllPermissions
});
//#endregion
export { r as useAllPermissionsQuery };
